import { useCallback, useEffect, useRef } from 'react'

interface AbortControllerState {
  controller: AbortController
  signal: AbortSignal
}

const useAbortController = () => {
  const abortControllerRef = useRef<AbortControllerState>({
    controller: new AbortController(),
    signal: new AbortController().signal
  })

  const isAborted = useCallback(() => {
    return abortControllerRef.current.signal.aborted
  }, [])

  const getSignal = useCallback(() => {
    return abortControllerRef.current.signal
  }, [])

  const abort = useCallback(() => {
    // Create a new controller for future requests
    if (!abortControllerRef.current.signal.aborted) {
      abortControllerRef.current.controller.abort()
    }
    abortControllerRef.current = {
      controller: new AbortController(),
      signal: new AbortController().signal
    }
    return abortControllerRef.current.signal
  }, [])

  useEffect(() => {
    return () => {
      if (!abortControllerRef.current.signal.aborted) {
        abortControllerRef.current.controller.abort()
      }
    }
  }, [])

  return { getSignal, abort, isAborted }
}

export default useAbortController
